<template>
 <svg :style="style"   width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame">
<path id="Vector" d="M12.8006 10.7671C10.8006 11.3005 9.46731 12.6338 9.06731 14.3671C8.40064 17.0338 10.0006 18.6338 11.0673 19.9671C12.134 21.0338 12.534 21.5671 12.134 22.2338C11.734 23.3005 11.0673 23.7005 10.2673 24.2338C9.33397 24.9005 8.13397 25.8338 8.40064 27.9671C8.53397 29.1671 9.20064 30.1005 10.134 30.6338C10.8006 31.0338 11.6006 31.1671 12.534 31.1671C14.0006 31.1671 15.6006 30.7671 17.2006 29.8338C20.934 27.9671 23.4673 24.5005 24.134 20.7671C24.6673 18.1005 24.0006 15.5671 22.534 13.8338C20.134 11.3005 16.134 9.96712 12.8006 10.7671ZM24.0006 10.7671C24.6673 9.96712 24.8006 8.90046 24.2673 8.36712C23.734 7.83379 22.6673 8.23379 22.0006 9.03379C21.334 9.83379 21.2006 10.9005 21.734 11.4338C22.2673 11.9671 23.334 11.5671 24.0006 10.7671ZM18.8006 9.83379C19.4673 10.1005 20.4006 9.56712 20.8006 8.63379C21.334 7.56712 21.0673 6.63379 20.4006 6.23379C19.734 5.83379 18.8006 6.50046 18.4006 7.43379C18.0006 8.36712 18.134 9.43379 18.8006 9.83379ZM15.334 9.30046C16.0006 9.43379 16.8006 8.50046 16.934 7.43379C17.0673 6.36712 16.534 5.43379 15.8673 5.30046C15.2006 5.16712 14.4006 6.10046 14.2673 7.16712C14.134 8.23379 14.6673 9.16712 15.334 9.30046ZM10.534 9.70046C11.334 9.43379 12.0006 8.76712 12.2673 7.83379C12.534 7.03379 12.534 6.10046 12.134 5.16712C11.8673 4.36712 11.334 3.56712 10.534 3.16712C9.73397 2.63379 8.93397 2.50046 8.13397 2.76712C6.53397 3.30046 5.86731 5.30046 6.53397 7.30046C6.80064 8.10046 7.33397 8.90046 8.13397 9.30046C8.66731 9.56712 9.20064 9.83379 9.73397 9.83379C10.0006 9.83379 10.2673 9.83379 10.534 9.70046ZM27.2006 11.3005C26.6673 10.7671 25.6006 10.9005 24.8006 11.5671C24.0006 12.2338 23.6006 13.3005 24.134 13.8338C24.6673 14.3671 25.734 14.2338 26.534 13.5671C27.334 12.9005 27.734 11.8338 27.2006 11.3005Z" fill="white"/>
</g>
</svg>



</template>

<script>
export default {
  name: 'icon-ekgygjss',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>